import {
  LowIncomeSubsidyAmount,
  LowIncomeSubsidyOption,
  LowIncomeSubsidyStatus,
} from "../@types";
import { CONSTANTS } from "./CONSTANTS";

const { LIS_NO_HELP } = LowIncomeSubsidyStatus;

export const getLisToUse = ({
  lis = LIS_NO_HELP,
  futureLis,
  currentPlanYear,
  contractYear,
}: {
  futureLis: LowIncomeSubsidyStatus | undefined;
  lis: LowIncomeSubsidyStatus | undefined;
  currentPlanYear: number;
  contractYear: string;
}): LowIncomeSubsidyStatus => {
  // if futureLis is undefined, it means that it is an anonymous user
  // where we use lis for both years
  return currentPlanYear.toString() === contractYear
    ? lis
    : futureLis
    ? futureLis
    : lis;
};

export const getLowIncomeSubsidyStatusLabel = (
  year: string,
  level: LowIncomeSubsidyStatus
): string =>
  isLowIncomeSubsidyStatusLabelAvailable(year, level)
    ? CONSTANTS.lowIncomeSubsidyStatusLabels[year][level]
    : `missing ${year} phrase key for ${level}`;

export const isLowIncomeSubsidyStatusLabelAvailable = (
  year: string,
  level: LowIncomeSubsidyStatus
): boolean => {
  if (CONSTANTS.lowIncomeSubsidyStatusLabels[year]) {
    return CONSTANTS.lowIncomeSubsidyStatusLabels[year][level] ? true : false;
  } else {
    return false;
  }
};

export const getNewLISCodeFromUserOptions = (
  helpType: LowIncomeSubsidyOption | undefined,
  amountOfSSHelp: LowIncomeSubsidyAmount | null
): LowIncomeSubsidyStatus | null => {
  if (helpType === LowIncomeSubsidyOption.Medicaid) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1A;
  }
  if (helpType === LowIncomeSubsidyOption.SSI) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1A_DN;
  }
  if (helpType === LowIncomeSubsidyOption.MSP) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1B;
  }
  if (helpType === LowIncomeSubsidyOption.Unsure) {
    return LowIncomeSubsidyStatus.LIS_NO_HELP;
  }
  if (
    helpType === LowIncomeSubsidyOption.SS &&
    amountOfSSHelp === LowIncomeSubsidyAmount.HelpNA
  ) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_1C;
  }
  if (
    helpType === LowIncomeSubsidyOption.SS &&
    amountOfSSHelp === LowIncomeSubsidyAmount.Help0
  ) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_4_100;
  }
  if (
    helpType === LowIncomeSubsidyOption.SS &&
    amountOfSSHelp === LowIncomeSubsidyAmount.Help25
  ) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_4_75;
  }
  if (
    helpType === LowIncomeSubsidyOption.SS &&
    amountOfSSHelp === LowIncomeSubsidyAmount.Help50
  ) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_4_50;
  }
  if (
    helpType === LowIncomeSubsidyOption.SS &&
    amountOfSSHelp === LowIncomeSubsidyAmount.Help75
  ) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_4_25;
  }
  if (
    helpType === LowIncomeSubsidyOption.SS &&
    amountOfSSHelp === LowIncomeSubsidyAmount.HelpUnsure
  ) {
    return LowIncomeSubsidyStatus.LIS_LEVEL_4_100;
  }
  return LowIncomeSubsidyStatus.LIS_NO_HELP;
};
